<template>
    <div
        class="md-hero layout4 banner-with-search-bar mg-bg"
        :class="[
            isVideoPlay &&
                videoOption &&
                (videoOption.autoplay || videoOption.playInline)
                ? 'video-in-play'
                : ''
        ]"
        :style="{
            ...colorStyle,
            ...spaceStyle
        }"
    >
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
            :rawDot="true"
            :getBannerStyle="getBannerStyle"
        >
            <media-content
                :title="title"
                :subTitle="subTitle"
                :showShadow="showShadow"
                class="media-content-search-bar f-col"
                v-animated="{name: 'appear-down', enable: showAnimationEffects}"
            >
                <template #info>
                    <div
                        v-if="useType === 'video'"
                        class="play-video"
                        @click.stop="doVideoPlay"
                    ></div>
                </template>
                <div v-if="useType === 'video'" class="video-loading"></div>
                <div
                    class="media-content-box media-content-box-layout4"
                    @click="avoidEmitMedia"
                >
                    <component
                        :is="searchBar"
                        :needSearchCondition="true"
                        :configFilter="configFilter"
                        :placeholder="searchbarPlaceholder"
                        :submitText="computedSearchBtnText"
                        :class="searchBarLayout"
                        class="row2column"
                        :agreementData="agreementData"
                    />
                </div>
            </media-content>
        </banner>
    </div>
</template>

<script>
import common from '../index.js';
import mixinsSearchBar from './mixins-search-bar';
import MediaContent from '../../../components/media-content-v2.vue';
export default {
    mixins: [common, mixinsSearchBar],
    components: {
        MediaContent
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-hero.layout4 {
    .banner {
        align-items: flex-start;
    }
    .media-content-v2 {
        margin-top: 288px;
        .media-info {
            width: 100%;
            max-width: 100%;
            margin-bottom: 40px;
            @include media-800 {
                margin-bottom: 20px;
            }
        }
        .title-text {
            padding: 0;

            .site-subtitle {
                margin-top: 30px;
                @include media-800 {
                    margin-top: 15px;
                }
            }
        }
        .media-content-box-layout4 {
            width: 100%;
            max-width: 100%;
        }
    }
    .banner-video + .media-content-v2 {
        .title-text .media-shadow {
            display: none;
        }
        @include media-min-1080 {
            &.row {
                .play-video {
                    margin: 10px auto;
                }
            }
        }
        .play-video {
            margin: 10px auto 10px;
            width: 84px;
            height: 84px;
            border-radius: 50%;
            background-image: url(//static.chimeroi.com/site3/images/play.png);
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;
            cursor: pointer;
            pointer-events: all;
            &:before {
                content: '';
                position: absolute;
                left: -7px;
                top: -7px;
                width: calc(100% + 14px);
                height: calc(100% + 14px);
                border-radius: 50%;
                background-color: rgba(255, 255, 255, 0.4);
            }
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
                &:before {
                    left: -4px;
                    top: -4px;
                    width: calc(100% + 8px);
                    height: calc(100% + 8px);
                }
            }
        }
        .video-loading {
            display: none;
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif)
                no-repeat;
            background-size: cover;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
    }
    .banner-video.autoplay + .media-content-v2,
    .banner-video.is-play + .media-content-v2 {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .media-content-v2 {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
        display: none;
    }

    .banner-video {
        .play-video,
        .video-loading {
            display: none;
        }
    }
    .swiper-horizontal > .swiper-pagination-bullets {
        bottom: 20px;
        .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-left: 6px;
            margin-right: 6px;
            background-color: white;
            opacity: 0.5;
            &.swiper-pagination-bullet-active {
                opacity: 1;
            }
        }
    }
}
</style>
